<div class="header-container">
  <div class="name" [class.menu-open]="isMobileMenuOpen">
    <a routerLink="/">
      <h3>Jona<span>s</span></h3>
    </a>
  </div>

  <div
    class="menu-toggle"
    [class.open]="isMobileMenuOpen"
    (click)="toggleMobileMenu()"
  >
    <span></span>
    <span></span>
    <span></span>
  </div>

  <nav class="desktop-nav">
    <div class="menu">
      <a href="#about-me">{{ "HEADER.ABOUT" | translate }}</a>
      <a href="#skills">{{ "HEADER.SKILLS" | translate }}</a>
      <a href="#portfolio">{{ "HEADER.PORTFOLIO" | translate }}</a>
    </div>
    <div class="languageBtn">
      <button
        [class.active]="activeLanguage === 'de'"
        (click)="setLanguage('de')"
      >
        DE
      </button>
      <button
        [class.active]="activeLanguage === 'en'"
        (click)="setLanguage('en')"
      >
        EN
      </button>
    </div>
  </nav>

  <div class="mobile-menu-overlay" [class.open]="isMobileMenuOpen">
    <a href="#about-me" (click)="toggleMobileMenu()">{{
      "HEADER.ABOUT" | translate
    }}</a>
    <a href="#skills" (click)="toggleMobileMenu()">{{
      "HEADER.SKILLS" | translate
    }}</a>
    <a href="#portfolio" (click)="toggleMobileMenu()">{{
      "HEADER.PORTFOLIO" | translate
    }}</a>
    <div class="languageBtn">
      <button
        [class.active]="activeLanguage === 'de'"
        (click)="setLanguage('de')"
      >
        DE
      </button>
      /
      <button
        [class.active]="activeLanguage === 'en'"
        (click)="setLanguage('en')"
      >
        EN
      </button>
    </div>
  </div>
</div>
